import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export const ScheduleCall = () => {
  return (
    <div className="min-h-screen pb-20">
      {/* Header */}
      <section className="pt-24 lg:pt-32 pb-12 lg:pb-20 bg-muted/30">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-display font-bold mb-6">
            Schedule a Call with Evolution GEO
          </h1>
          <p className="text-lg sm:text-xl text-muted-foreground max-w-2xl mx-auto">
            Pick a time that works for you and we&apos;ll walk through your GEO/AIO, AI ads, and automation goals together.
          </p>
        </div>
      </section>

      {/* Placeholder for scheduling widget */}
      <section className="py-16">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <Card className="border-border shadow-sm">
            <CardHeader>
              <CardTitle className="font-display text-2xl">
                Book Your Discovery Call
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="h-[480px] rounded-lg border border-dashed border-border bg-muted/40 flex items-center justify-center text-sm text-muted-foreground text-center px-4">
                Cal.com scheduling widget will appear here.
                <br />
                We&apos;ll embed your Cal.com code on this canvas so prospects can book directly into your calendar.
              </div>
            </CardContent>
          </Card>
        </div>
      </section>
    </div>
  );
};

